export default {
  icons: {
    "MF Next": {
      "0": { //Abbattitore - Raffreddamento
        icon: "icon-function_chilling",
        loader: true
      },                  
      "1": { //Abbattitore - Surgelazione
        icon: "icon-function_freezing",
        loader: true
      }, 
      "2": { //Abbattitore - Mantenimento freddo
        icon: "icon-function_cold_holding",
        loader: false
      },
      "3": { //Abbattitore - Mantenimento caldo
        icon: "icon-function_warm_holding",
        loader: false
      },
      "4": { //Abbattitore - Scongelamento
        icon: "icon-function_thawing",
        loader: true
      },
      "5": { //Abbattitore - Pronto al servizio
        icon: "icon-function_ready",
        loader: false
      },
      "6": { //Abbattitore - Cottura bassa temperatura
        icon: "icon-function_low_temperture_cooking",
        loader: true
      },
      "7": { //Abbattitore - Lievitazione diretta
        icon: "icon-function_proofing",
        loader: true
      },
      "8": { //Abbattitore - Lievitazione programmata
        icon: "icon-function_planned_proofing",
        loader: false
      },
      "9": { //Abbattitore - Lievitazioni multipla
        icon: "icon-function_retarder_proofing",
        loader: true
      }, 
      "10": { //Abbattitore - Cioccolato
        icon: "icon-function_chocolate",
        loader: true
      },
      "11": { //Abbattitore - Pastorizzazione
        icon: "icon-function_pasteurization",
        loader: true
      },
      "12": { //Abbattitore - Essicazione
        icon: "icon-function_drying",
        loader: true
      },
      "13": { //Abbattitore - Ciclo continuo
        icon: "icon-function_non_stop",
        loader: true
      },
      "14": { //Abbattitore - Sbrinamento
        icon: "icon-function_defrosting",
        loader: true
      },
      "15": { //Abbattitore - Marinatura
        icon: "icon-mf_function_15",
        loader: true
      }
    },
    "EF Next": {
      "1": { //Abbattitore - Abbattimento
        icon: "icon-ef_function_01",
        loader: true
      }, 
      "2": { //Abbattitore - Surgelazione
        icon: "icon-ef_function_02",
        loader: false
      },
      "3": { //Abbattitore - Non-stop
        icon: "icon-ef_function_03",
        loader: false
      },
      "4": { //Abbattitore - Mantenimento freddo
        icon: "icon-ef_function_04",
        loader: true
      },
      "5": { //Abbattitore - Scongelamento
        icon: "icon-ef_function_05",
        loader: false
      },
      "6": { //Abbattitore - Marinatura
        icon: "icon-ef_function_06",
        loader: true
      },
      "7": { //Abbattitore - Rinvenimento gelato
        icon: "icon-ef_function_07",
        loader: true
      },
      "20": { //Abbattitore - Sbrinamento
        icon: "icon-ef_function_20",
        loader: true
      }
    },
    "SF": {
      "1": { //Abbattitore - Abbattimento
        icon: "icon-ef_function_01",
        loader: true
      }, 
      "2": { //Abbattitore - Surgelazione
        icon: "icon-ef_function_02",
        loader: false
      },
      "3": { //Abbattitore - Non-stop
        icon: "icon-ef_function_03",
        loader: false
      },
      "4": { //Abbattitore - Mantenimento freddo
        icon: "icon-ef_function_04",
        loader: true
      },
      "5": { //Abbattitore - Scongelamento
        icon: "icon-ef_function_05",
        loader: false
      },
      "6": { //Abbattitore - Marinatura
        icon: "icon-ef_function_06",
        loader: true
      },
      "7": { //Abbattitore - Rinvenimento gelato
        icon: "icon-ef_function_07",
        loader: true
      },
      "20": { //Abbattitore - Sbrinamento
        icon: "icon-ef_function_20",
        loader: true
      }
    },
    "CP": {
      "standby": { //Conservatore - Standby
        icon: "icon-air_temp_small",
        loader: false
      },
      "cool": { //Conservatore - Cool
        icon: "icon-air_temp_small",
        loader: true
      },
      "defrost": { //Conservatore - Defrost
        icon: "icon-defrosting",
        loader: true
      }
    },
    "CK": {
      "standby": { //Conservatore - Standby
        icon: "icon-air_temp_small",
        loader: false
      },
      "cool": { //Conservatore - Cool
        icon: "icon-air_temp_small",
        loader: true
      },
      "defrost": { //Conservatore - Defrost
        icon: "icon-defrosting",
        loader: true
      }
    },
    "MYA": {
      "1": { svg: "/mya/mya_cycle_0.svg", loader: false },
      "2": { svg: "/mya/mya_cycle_1.svg", loader: false },
      "3": { svg: "/mya/mya_cycle_2.svg", loader: false },
      "4": { svg: "/mya/mya_cycle_3.svg", loader: false },
      "5": { svg: "/mya/mya_cycle_4.svg", loader: false },
      "6": { svg: "/mya/mya_cycle_5.svg", loader: false },
      "7": { svg: "/mya/mya_cycle_6.svg", loader: false },
      "8": { svg: "/mya/mya_cycle_7.svg", loader: false },
      "9": { svg: "/mya/mya_cycle_8.svg", loader: false },
      "10": { svg: "/mya/mya_cycle_9.svg", loader: false },
      "11": { svg: "/mya/mya_cycle_10.svg", loader: false },
      "12": { svg: "/mya/mya_cycle_11.svg", loader: false },
      "13": { svg: "/mya/mya_cycle_12.svg", loader: false },
      "14": { svg: "/mya/mya_cycle_13.svg", loader: false },
      "15": { svg: "/mya/mya_cycle_14.svg", loader: false },
      "16": { svg: "/mya/mya_cycle_15.svg", loader: false },
      "17": { svg: "/mya/mya_cycle_16.svg", loader: false },
      "18": { svg: "/mya/mya_cycle_17.svg", loader: false },
      "19": { svg: "/mya/mya_cycle_18.svg", loader: false },
      "20": { svg: "/mya/mya_cycle_19.svg", loader: false },
      "21": { svg: "/mya/mya_cycle_20.svg", loader: false },
      "22": { svg: "/mya/mya_cycle_21.svg", loader: false },
      "23": { svg: "/mya/mya_cycle_22.svg", loader: false },
      "24": { svg: "/mya/mya_cycle_23.svg", loader: false },
      "25": { svg: "/mya/mya_cycle_24.svg", loader: false },
      "26": { svg: "/mya/mya_cycle_25.svg", loader: false },
      "27": { svg: "/mya/mya_cycle_26.svg", loader: false },
      "28": { svg: "/mya/mya_cycle_27.svg", loader: false },
      "29": { svg: "/mya/mya_cycle_28.svg", loader: false },
      "30": { svg: "/mya/mya_cycle_29.svg", loader: false },
      "31": { svg: "/mya/mya_cycle_30.svg", loader: false },
      "32": { svg: "/mya/mya_cycle_31.svg", loader: false },
      "33": { svg: "/mya/mya_cycle_32.svg", loader: false },
      "34": { svg: "/mya/mya_cycle_33.svg", loader: false },
      "35": { svg: "/mya/mya_cycle_34.svg", loader: false },
      "36": { svg: "/mya/mya_cycle_35.svg", loader: false },
      "37": { svg: "/mya/mya_cycle_36.svg", loader: false },
      "38": { svg: "/mya/mya_cycle_37.svg", loader: false },
      "39": { svg: "/mya/mya_cycle_38.svg", loader: false },
      "40": { svg: "/mya/mya_cycle_39.svg", loader: false },
      "41": { svg: "/mya/mya_cycle_40.svg", loader: false },
      "42": { svg: "/mya/mya_cycle_41.svg", loader: false },
      "43": { svg: "/mya/mya_cycle_42.svg", loader: false },
      "44": { svg: "/mya/mya_cycle_43.svg", loader: false },
      "45": { svg: "/mya/mya_cycle_44.svg", loader: false },
      "46": { svg: "/mya/mya_cycle_45.svg", loader: false },
      "47": { svg: "/mya/mya_cycle_46.svg", loader: false },
      "48": { svg: "/mya/mya_cycle_47.svg", loader: false },
      "49": { svg: "/mya/mya_cycle_48.svg", loader: false },
      "50": { svg: "/mya/mya_cycle_49.svg", loader: false },
      "51": { svg: "/mya/mya_cycle_50.svg", loader: false },
      "52": { svg: "/mya/mya_cycle_51.svg", loader: false },
      "53": { svg: "/mya/mya_cycle_52.svg", loader: false },
      "54": { svg: "/mya/mya_cycle_53.svg", loader: false },
      "55": { svg: "/mya/mya_cycle_54.svg", loader: false },
      "56": { svg: "/mya/mya_cycle_55.svg", loader: false },
      "57": { svg: "/mya/mya_cycle_56.svg", loader: false },
      "58": { svg: "/mya/mya_cycle_57.svg", loader: false },
      "59": { svg: "/mya/mya_cycle_58.svg", loader: false },
      "60": { svg: "/mya/mya_cycle_59.svg", loader: false },
      "61": { svg: "/mya/mya_cycle_60.svg", loader: false },
      "62": { svg: "/mya/mya_cycle_61.svg", loader: false },
      "63": { svg: "/mya/mya_cycle_62.svg", loader: false },
      "64": { svg: "/mya/mya_cycle_63.svg", loader: false },
      "65": { svg: "/mya/mya_cycle_64.svg", loader: false },
      "66": { svg: "/mya/mya_cycle_65.svg", loader: false },
      "67": { svg: "/mya/mya_cycle_66.svg", loader: false },
      "68": { svg: "/mya/mya_cycle_67.svg", loader: false },
      "69": { svg: "/mya/mya_cycle_68.svg", loader: false },
      "70": { svg: "/mya/mya_cycle_69.svg", loader: false },
      "71": { svg: "/mya/mya_cycle_70.svg", loader: false },
      "72": { svg: "/mya/mya_cycle_71.svg", loader: false },
      "73": { svg: "/mya/mya_cycle_72.svg", loader: false },
      "74": { svg: "/mya/mya_cycle_73.svg", loader: false },
      "75": { svg: "/mya/mya_cycle_74.svg", loader: false },
      "76": { svg: "/mya/mya_cycle_75.svg", loader: false },
      "77": { svg: "/mya/mya_cycle_76.svg", loader: false },
      "78": { svg: "/mya/mya_cycle_77.svg", loader: false },
      "79": { svg: "/mya/mya_cycle_78.svg", loader: false },
      "80": { svg: "/mya/mya_cycle_79.svg", loader: false },
      "81": { svg: "/mya/mya_cycle_80.svg", loader: false },
      "82": { svg: "/mya/mya_cycle_81.svg", loader: false },
      "83": { svg: "/mya/mya_cycle_82.svg", loader: false },
      "84": { svg: "/mya/mya_cycle_83.svg", loader: false },
      "85": { svg: "/mya/mya_cycle_84.svg", loader: false },
      "86": { svg: "/mya/mya_cycle_85.svg", loader: false },
      "87": { svg: "/mya/mya_cycle_86.svg", loader: false },
      "88": { svg: "/mya/mya_cycle_87.svg", loader: false },
      "89": { svg: "/mya/mya_cycle_88.svg", loader: false },
      "90": { svg: "/mya/mya_cycle_89.svg", loader: false },
      "91": { svg: "/mya/mya_cycle_90.svg", loader: false },
      "92": { svg: "/mya/mya_cycle_91.svg", loader: false },
      "93": { svg: "/mya/mya_cycle_92.svg", loader: false },
      "94": { svg: "/mya/mya_cycle_93.svg", loader: false },
      "95": { svg: "/mya/mya_cycle_94.svg", loader: false },
      "96": { svg: "/mya/mya_cycle_95.svg", loader: false },
      "97": { svg: "/mya/mya_cycle_96.svg", loader: false },
      "98": { svg: "/mya/mya_cycle_97.svg", loader: false },
      "99": { svg: "/mya/mya_cycle_98.svg", loader: false },
      "100": { svg: "/mya/mya_cycle_99.svg", loader: false },
      "101": { svg: "/mya/mya_cycle_100.svg", loader: false },
      "102": { svg: "/mya/mya_cycle_101.svg", loader: false },
      "103": { svg: "/mya/mya_cycle_102.svg", loader: false },
      "104": { svg: "/mya/mya_cycle_103.svg", loader: false },
      "105": { svg: "/mya/mya_cycle_104.svg", loader: false },
      "106": { svg: "/mya/mya_cycle_105.svg", loader: false },
      "107": { svg: "/mya/mya_cycle_106.svg", loader: false },
      "108": { svg: "/mya/mya_cycle_107.svg", loader: false },
      "109": { svg: "/mya/mya_cycle_108.svg", loader: false },
      "110": { svg: "/mya/mya_cycle_109.svg", loader: false },
      "111": { svg: "/mya/mya_cycle_110.svg", loader: false },
      "112": { svg: "/mya/mya_cycle_111.svg", loader: false },
      "113": { svg: "/mya/mya_cycle_112.svg", loader: false },
      "114": { svg: "/mya/mya_cycle_113.svg", loader: false },
      "115": { svg: "/mya/mya_cycle_114.svg", loader: false }
    },
    "MP Next": {
      "0": { //Fermalievita - Standby
        icon: "icon-air_temp_small",
        loader: false
      },
      "1": { //Fermalievita - Lievitazione continua / Cool - Modalità freddo negativo
        icon: "icon-air_temp_small",
        loader: true
      },
      "2": { //Fermalievita - Lievitazione diretta / Cool - Modalità freddo positivo
        icon: "icon-air_temp_small",
        loader: true
      },
      "3": { //Fermalievita - Lievitazione programmata / Cool - Modalità cioccolato
        icon: "icon-air_temp_small",
        loader: true
      },
      "4": { //Fermalievita - Defrost
        icon: "icon-defrosting",
        loader: true
      }
    },
  }
}
